"use client";

import { twMerge } from "tailwind-merge";

import { useUpdateQuery } from "@/hooks/use-update-query";

import { ChargeDuration } from "../../data/duration";

type Params = {
  duration: ChargeDuration;
  durationTexts: Record<ChargeDuration, string>;
  containerClassName?: string;
  buttonClassName?: string;
};

export const DurationSwitch = ({
  duration,
  durationTexts,
  containerClassName,
  buttonClassName,
}: Params) => {
  const { updateQuery } = useUpdateQuery();
  const toggleDuration = (d: ChargeDuration) => {
    updateQuery({ name: "duration", value: d });
  };

  return (
    <div
      className={twMerge(
        "flex w-fit items-center gap-1 rounded-full bg-white/20 p-1",
        containerClassName
      )}
      aria-label="toggle payment duration"
    >
      {Object.entries(durationTexts).map(([buttonDuration, text]) => (
        <button
          key={buttonDuration}
          className={twMerge(
            "rounded-full px-5 py-1 font-semibold text-zinc-600",
            buttonDuration === duration && "bg-sky-600 text-white",
            buttonClassName
          )}
          onClick={() => toggleDuration(buttonDuration as ChargeDuration)}
          aria-label={buttonDuration}
        >
          <p className="text-sm">{text}</p>
        </button>
      ))}
    </div>
  );
};
